import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import CustomAlert from "../../helpers/CustomAlert";
import { format, parse } from "date-fns";
import Loader from "../Loader/Loader";
import CustomerFilterModal from "./CustomerFilterModal";
import { useDispatch, useSelector } from "react-redux";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { setBalance } from "../store/balance/balanceSlice";
import FullStatement from "../transactionReport/FullStatement";
import DownloadReport from "../transactionReport/DownloadReport";
import confetti from "canvas-confetti";

const defaultFilterData = {
  channel: "", // Function Type
  name: "",
  mobileNumber: "",
  emailId: "",
  createdDate: "",
};

const CustomerEnquiries = ({ fetchData }) => {
  const pageSize = 10;
  const { user } = useSelector((state) => state.auth);
  const [noData, setNoData] = useState(false);
  const [ledgerData, setLedgerData] = useState([]);
  const loggedInUserName = sessionStorage.getItem("username") || "admin";
  const [pageDetails, setPageDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpenReport, setIsModalOpenReport] = useState(false);
  const [isModalOpenReportDown, setIsModalOpenReportDown] = useState(false);
  const [downloadReportData, setDownloadReportData] = useState([]);
  const [loadingFullSt, setLoadingFullSt] = useState(false);
  const [loadingDowRep, setLoadingDowRep] = useState(false);
  const [pageDowRepDetails, setPageDowRepDetails] = useState(null);
  const [noDowRepData, setNoDowRepData] = useState(false);

  const openModalFilter = () => setIsModalOpenFilter(true);
  const closeModalFilter = () => setIsModalOpenFilter(false);
  const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
  };

  const CustomerHeader = [
    "Serial Number",
    "Function Type",
    "Customer Name",
    "Mobile Number",
    "Email ID",
    "Enquiry Date and Time",
  ];

  const CustomerHeaderToKeyMap = {
    "Serial Number": "serialNumber",
    "Function Type": "channel",
    "Customer Name": "name",
    "Mobile Number": "mobileNumber",
    "Email ID": "emailId",
    "Enquiry Date and Time": "createdDate",
  };

  useEffect(() => {
    fetchUserData(1, filterData);
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const openModalReport = () => {
    setIsModalOpenReport(true);
  };

  const closeModalReport = () => {
    setIsModalOpenReport(false);
  };
  const openModalReportDown = () => {
    setIsModalOpenReportDown(true);
  };

  const closeModalReportDown = () => {
    setIsModalOpenReportDown(false);
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          fetchData(1);
        } else {
          console.warn("Dashboard data fetch failed:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      });
  };

  const getReadableFunctionType = (value) => {
    switch (value?.toLowerCase()) {
      case "sms":
        return "SMS";
      case "email":
        return "Email";
      case "rcs":
        return "RCS";
      case "whatsapp":
        return "WhatsApp";
      default:
        return value || "-";
    }
  };

  const modifyStructure = (response, pageNo) => {
    return response?.map((user, index) => {
      const CreatedDateParsed = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedDateTime = CreatedDateParsed
        ? `${format(CreatedDateParsed, "dd-MM-yyyy")} ${format(
            CreatedDateParsed,
            "HH:mm:ss"
          )}`
        : "-";

      return {
        // serialNumber: String(index + 1), // ✅ Ensure it's a string
        serialNumber: String(index + 1 + (pageNo - 1) * pageSize),

        channel: getReadableFunctionType(user?.channel),
        name: user?.name || "-",
        mobileNumber: user?.mobileNumber || "-",
        emailId: user?.emailId || "-",
        createdDate: formattedDateTime
          ? [
              format(CreatedDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(CreatedDateParsed, "HH:mm:ss"),
            ]
          : ["-", <br key={index} />, "-"],
      };
    });
  };

  const fetchUserData = async (currentPage, filterData) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        channel: filterData?.channel?.label || "",
        fromDate: formatDate(filterData?.fromDate),
        toDate: formatDate(filterData?.toDate),
      };

      setLoading(true);

      const response = await axiosPostApi(
        `${apiList.FETCH_CUSTOMER_ENQUIRIES}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data, currentPage);
        setLedgerData(modifiedData);
        setNoData(modifiedData.length === 0);
        fetchDashboardData();
      } else {
        setNoData(true);
        setLedgerData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "No Data",
            text: "No data available for the specified criteria.",
            icon: "info",
            confirmButtonText: "Okay",
          });
        }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const styleId = "customer-enquiries-style";

    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;

      style.innerHTML = `
      /* Center all headers */
      table thead th {
        text-align: center !important;
        padding: 6px 8px !important;
      }

      /* Center specific data columns */
      table tbody td:nth-child(1), /* Serial Number */
      table tbody td:nth-child(2), /* Function Type */
      table tbody td:nth-child(3), /* Name */
      table tbody td:nth-child(4), /* Mobile Number */
      table tbody td:nth-child(5), /* Email ID */
      table tbody td:nth-child(6)  /* Enquiry Date and Time */
      {
        text-align: center !important;
      }

      /* Reduce padding for all cells */
      table tbody td {
        padding: 6px 8px !important;
        font-size: 13px;
      }

      /* Reduce column width of Serial Number and Function Type */
      table thead th:nth-child(1),
      table tbody td:nth-child(1) {
        width: 60px !important;
        max-width: 60px !important;
        min-width: 60px !important;
      }

      table thead th:nth-child(2),
      table tbody td:nth-child(2) {
        width: 100px !important;
        max-width: 100px !important;
        min-width: 100px !important;
      }
    `;

      document.head.appendChild(style);
    }

    return () => {
      const el = document.getElementById(styleId);
      if (el) el.remove();
    };
  }, []);

  const handleFullStatement = async (fromDate, toDate) => {
    try {
      setLoadingFullSt(true);
      const payload = {
        username: user?.data?.username,
        fromDate,
        toDate,
      };

      const response = await axiosPostApi(
        `${apiList.CUSTOMER_ENQUIRIES_DOWNLOAD_HISTORY}`,
        payload
      );

      if (response.status === 200 && response.data.status === true) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message || "Success",
          icon: "success",
          confirmButtonText: "Ok",
        });
        closeModalReport();

        const canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.zIndex = "3000";
        document.body.appendChild(canvas);

        const confettiInstance = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        confettiInstance({
          particleCount: 250,
          spread: 100,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          document.body.removeChild(canvas);
        }, 3000);
      } else {
        setNoData(true);
        fetchUserData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "Failed",
            text: response?.data?.message || "Failed",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
      setLoadingFullSt(false);
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoadingFullSt(false);
    }
  };

  const handleDownloadReport = async (currentPage) => {
    setLoadingDowRep(true);
    setNoDowRepData(false);

    try {
      const requestBody = {
        username: user?.data?.username,
      };

      const response = await axiosPostApi(
        `${apiList.CUSTOMER_ENQUIRIES_DOWNLOAD_HISTORY_LIST}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (response && response.data) {
        if (response.data.status === true && response.data.respCode === "00") {
          const downloadHistory = response.data.data;
          setPageDowRepDetails(response.data.pageDetails);
          setDownloadReportData(downloadHistory || []);

          if (!downloadHistory || downloadHistory.length === 0) {
            setNoDowRepData(true);
          } else {
            setNoDowRepData(false);
          }
        } else {
          setDownloadReportData([]);
          setNoDowRepData(true);

          CustomAlert({
            title: "Failed",
            text: response.data.message || "Failed to fetch data",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else {
        setDownloadReportData([]);
        setNoDowRepData(true);
      }
    } catch (error) {
      console.error("Error fetching download history:", error);
      setDownloadReportData([]);
      setNoDowRepData(true);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoadingDowRep(false);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={CustomerHeader}
            data={ledgerData}
            filterFields={["companyName"]}
            entityType="CustomerEnquiries"
            headerToKeyMap={CustomerHeaderToKeyMap}
            loading={loading}
            noData={noData}
            pageDetails={pageDetails}
            currentPage={currentPage}
            totalRecord={totalRecord}
            handleReset={handleReset}
            setCurrentPage={setCurrentPage}
            fetchNextData={(pageNo) => fetchUserData(pageNo, filterData)}
            filterData={filterData}
            openModalFilter={openModalFilter}
            pageSize={pageSizeCount}
            fetchData={() => fetchUserData(1, defaultFilterData)}
            openModalSms={openModalReport}
            openModalSmsDown={openModalReportDown}
          />

          {isModalOpenFilter && (
            <CustomerFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setFilterData={setFilterData}
              filterData={filterData}
              handleReset={handleReset}
              setLedgerData={setLedgerData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSizeCount}
              setCurrentPage={setCurrentPage}
            />
          )}

          {isModalOpenReport ? (
            <FullStatement
              handleopenReport={isModalOpenReport}
              handleCloseReport={closeModalReport}
              callApi={handleFullStatement}
              loading={loadingFullSt}
            />
          ) : null}

          {isModalOpenReportDown ? (
            <DownloadReport
              handleopenReportDown={isModalOpenReportDown}
              handleCloseReportDown={closeModalReportDown}
              callApi={handleDownloadReport}
              data={downloadReportData}
              pageDowRepDetails={pageDowRepDetails}
              noData={noDowRepData}
              loading={loadingDowRep}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default CustomerEnquiries;
